import { Button } from './Button';

interface PagerProps {
  /** Pages already passed: each entry is the cursor that opens the page after it. */
  cursors: string[];
  next: string | null | undefined;
  onChange: (cursors: string[]) => void;
  labels: { previous: string; next: string };
}

/** Back and forth through a list that is read page by page. */
export function Pager({ cursors, next, onChange, labels }: PagerProps) {
  if (cursors.length === 0 && !next) return null;
  return (
    <div className="mt-6 flex justify-between">
      <Button
        variant="secondary"
        disabled={cursors.length === 0}
        onClick={() => onChange(cursors.slice(0, -1))}
      >
        {labels.previous}
      </Button>
      <Button
        variant="secondary"
        disabled={!next}
        onClick={() => next && onChange([...cursors, next])}
      >
        {labels.next}
      </Button>
    </div>
  );
}
